import { render, staticRenderFns } from "./CargoOccurrencesAttachments.vue?vue&type=template&id=2aeef460"
import script from "./CargoOccurrencesAttachments.vue?vue&type=script&lang=js"
export * from "./CargoOccurrencesAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports